import request from "./service";
import moment from "moment";

// 根据id获取token
export const getLoginTokenById = (data) => {
	return request({
		url: "/loginSan",
		method: "post",
		data: data
	})
}

// 获取用户云信账号 
export const getCurCloudUserInfo = (data) => {
	return request({
		url: "/ykf/user/getLoginInfo",
		method: "post",
		data: data
	})
}

export const getRecordsReverseOrder = (csId, pageNum, pageSize) => {
	const url = "/ykf/chattingrecords/getRecordsReverseOrder"
		+ `?customerAccid=${csId}`
		+ `&pageSize=${pageSize}`
		+ `&pageNum=${pageNum}`;
	return request({
		url: url,
		method: "get"
	});
}

export const addBatch = (customerAccid, userAccid, sessionId) => {
	const endTime = moment().format("x");
	const url = "/ykf/chattingrecords/addBatch"
		+ `?customerAccid=${customerAccid}`
		+ `&userAccid=${userAccid}`
		+ `&endTime=${endTime}`
		+ `&sessionId=${sessionId}`;
	console.log(`同步消息 : ${url}`);
	return request({
		url: url,
		method: "post"
	});
}

// 动态分配客服 
export const getCloudServiceInfo = (query) => {
	return request({
		url: "/ykf/serviceSession/create",
		method: "get",
		params: query
	})
}

// 心跳包
export const heartBeat = () => {
	return request({
		url: "/monitor/online/heartbeatTrigger",
		method: "get",
	})
}

// 会话打分
export const cloudRate = (data) => {
	return request({
		url: "/ykf/serviceSession/score",
		method: "post",
		data: data,
		headers: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	})
}

// 关闭会话
export function close(query) {
	return request({
		url: "/ykf/serviceSession/close",
		method: "get",
		params: query
	})
}

// 查询会话评分结果 
export function checkRateRes(query) {
	return request({
		url: "/ykf/serviceSession/getSessionStatus",
		method: "get",
		params: query
	})
}

// 发送消息使用，目的是检测超时
export function sendMsgToServerCheckOverTime(query) {
	return request({
		url: "/ykf/serviceSession/onlineTrigger",
		method: "get",
		params: query
	})
}